import { FC, useState } from "react";

import { IRichLogData } from "@ryde/shared";

import { RichLogsFilters } from "../../rich-logs-components";
import { useProductionViewLogs } from "../hooks";
import { ProductionLogsStatsWrapper } from "./production-logs.stats.wrapper";

interface IProductionLogFilters {
  logData: IRichLogData | undefined;
  filteredLogsCount: number | undefined;
  hasExternalLogs?: boolean;
  onRefreshLogsClick?: () => void;
  isRefreshLogsDisabled?: boolean;
}

export const ProductionLogsFilters: FC<IProductionLogFilters> = ({
  logData,
  filteredLogsCount,
  hasExternalLogs,
  onRefreshLogsClick,
  isRefreshLogsDisabled,
}) => {
  const [isStatsCollapsed, setIsStatsCollapsed] = useState(false);
  const { isFinished } = useProductionViewLogs();

  const toggleStats = (): void => {
    setIsStatsCollapsed(!isStatsCollapsed);
  };

  return (
    <RichLogsFilters
      isFinished={isFinished}
      logData={logData}
      hasExternalLogs={hasExternalLogs}
      isStatsCollapsed={isStatsCollapsed}
      syncFiltersCollapseWithStats
      onRefreshLogsClick={onRefreshLogsClick}
      isRefreshLogsDisabled={isRefreshLogsDisabled}
      bottomContent={
        <ProductionLogsStatsWrapper
          logData={logData}
          filteredLogsCount={filteredLogsCount}
          isStatsCollapsed={isStatsCollapsed}
          onToggleStats={toggleStats}
        />
      }
    ></RichLogsFilters>
  );
};
